module.exports = __webpack_public_path__ + "static/about-us-cover-74fc8d60d3309ae669eadece3f14c9de.jpg";